import type { TweaksState } from '@/shared/tweaks-defaults';
import { applyPalette } from '@/design-system/palettes';

export function applyTheme(tweaks: TweaksState): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  applyPalette(root, tweaks.palette);
  root.classList.remove('density-compact', 'density-airy');
  if (tweaks.density === 'compact') root.classList.add('density-compact');
  if (tweaks.density === 'airy') root.classList.add('density-airy');
  root.classList.toggle('dark', tweaks.dark);
  root.classList.toggle('display-sans', tweaks.displayFont === 'sans');
  root.style.setProperty('--route-opacity', String(tweaks.routeIntensity));
}
